(function () {
  function getDescEl() {
    return document.querySelector('[class*="__text_shade_desc"]');
  }

  function updateDesc(shade) {
    var descriptions = window.jscShadeDescriptions;
    if (!descriptions || !shade) return;
    var desc = descriptions[shade];
    var el = getDescEl();
    if (!el) return;
    if (desc) {
      el.innerHTML = '<p><em>' + desc + '</em></p>';
      el.style.display = '';
    } else {
      el.innerHTML = '';
      el.style.display = 'none';
    }
  }

  // Initial render — defer until DOM + inline data are ready
  document.addEventListener('DOMContentLoaded', function () {
    updateDesc(window.jscCurrentShade);
  });

  // Atelier fires a change event on the swatch radio on every variant switch
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.name) return;
    if (input.name.indexOf('variant_picker') !== -1 || input.name.indexOf('Color') !== -1) {
      updateDesc(input.value);
    }
  });
})();
